import React from 'react';
import logos from '../layout/pageheader.jpeg'

function Changelog() {
  return (
    <div>
      <div class="hero-section bg_img style-three" style={{ backgroundImage: `url(${logos})` }}>
        <div class="container">
            <div class="section-header cl-white">
                <h2 class="title">Changelog</h2>
                <p>Discover new features, bug fixes and update releases from Deskoto</p>
            </div>
        </div>
    </div>
    <section class="changelog-section padding-bottom mt--187 pos-rel">
        <div class="container">
            <div class="changelog-wrapper">
                <div class="changelog-item">
                    <span class="update-button">Update</span>
                    <h5 class="title">Deskoto Help Center v1.0 is released!</h5>
                    <span class="date">Updated over a week ago</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc molestie eu leo at consequat. Maecenas finibus pellentesque nibh, nec pretium nisl ultrices at. Ut est enim, egestas at purus non, viverra mollis arcu. Quisque leo felis, fringilla eu elementum vestibulum, consequat et mi.</p>
                </div>
                <div class="changelog-item">
                    <span class="update-button bug">Bug Fix</span>
                    <h5 class="title">Login Auth Issue Fixed on Deskoto</h5>
                    <span class="date">Updated over a week ago</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc molestie eu leo at consequat. Maecenas finibus pellentesque nibh, nec pretium nisl ultrices at. Ut est enim, egestas at purus non, viverra mollis arcu. Quisque leo felis, fringilla eu elementum vestibulum, consequat et mi.</p>
                </div>
                <div class="changelog-item">
                    <span class="update-button feature">Feature</span>
                    <h5 class="title">Deskoto new feature is released!</h5>
                    <span class="date">Updated over a week ago</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc molestie eu leo at consequat. Maecenas finibus pellentesque nibh, nec pretium nisl ultrices at. Ut est enim, egestas at purus non, viverra mollis arcu. Quisque leo felis, fringilla eu elementum vestibulum, consequat et mi.</p>
                </div>
                <div class="changelog-item">
                    <span class="update-button bug">Bug Fix</span>
                    <h5 class="title">Responsive Issues Fixed on Deskoto v0.3</h5>
                    <span class="date">Updated over a week ago</span>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc molestie eu leo at consequat. Maecenas finibus pellentesque nibh, nec pretium nisl ultrices at. Ut est enim, egestas at purus non, viverra mollis arcu. Quisque leo felis, fringilla eu elementum vestibulum, consequat et mi.</p>
                </div>
            </div>
        </div>
    </section>

    </div>
  );
}

export default Changelog;
